import { render, staticRenderFns } from "./programa-mod.vue?vue&type=template&id=f7b54300"
import script from "./programa-mod.vue?vue&type=script&lang=js"
export * from "./programa-mod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports